import { createFileRoute } from '@tanstack/react-router';
import { AutocaptureSettings } from '@/components/autocapture-settings';
import { EngagementSettings } from '@/components/engagement-settings';
import { PageContent } from '@/components/page-content';
import { useProjects } from '@/hooks/use-projects';

export const Route = createFileRoute(
  '/_auth/_side-layout/project-settings/autocapture',
)({
  component: AutocaptureSettingsRoute,
});

function AutocaptureSettingsRoute() {
  const { projectId } = useProjects();

  return (
    <PageContent>
      {/* key={projectId} resets the autocapture draft (master + per-type
          toggles) when the active project changes — active project is global
          state, not a route param, so this route wouldn't otherwise remount. */}
      <AutocaptureSettings key={projectId} />
      <EngagementSettings key={`engagement-${projectId}`} />
    </PageContent>
  );
}
